
import { Component, Vue } from 'vue-property-decorator';
import Footer from './components/Footer.vue';
import tFooterInfo from './components/tFooterInfo.vue';
import SubHeader from './components/subdetailHeader.vue';

@Component({
  name: 'mainLayout',
  components: {
    SubHeader,
    Footer,
    tFooterInfo,
  },
})

export default class extends Vue {
  private heightFix = false;

  private menuList: any = [];

  private fixHeight() {
    this.heightFix = !this.heightFix;
  }
}
